<div>
    <p [hidden]="additionalInfoShow">{{ 'console.for-hour-chooser.no-free-reservation' | translate }}</p>
    <div>
        <button class="btn btn-primary" [ngClass]="{'big-padding-button mb-1 mr-1': screenSizeType == ScreenSizeTypeEnum.BIG, 'slim-padding-button mb-2 mr-2 ml-2' : screenSizeType == ScreenSizeTypeEnum.SLIM, 'small-padding-button mb-2 mr-2 ml-2' : screenSizeType == ScreenSizeTypeEnum.SMALL }" (click)="onReservationTimeClick(timeCell)"  *ngFor="let timeCell of timeCells">{{ timeCell.time }}</button>
    </div>
</div>